// src/utils/pageAccess.js — which permission opens each page (menu + page guard)
// [marker: permissions-real v1] the server enforces the same rules on the data itself
const EV = ['events.view', 'events.edit', 'events.checkin'];
const PAGES = [
  [/^\/$/, null],
  [/^\/members(\/|$)/, ['members.view']],
  [/^\/(contacts|contact-tags)(\/|$)/, ['contacts.view']],
  [/^\/events\/[^/]+\/badges/, ['events.checkin', 'events.edit']],
  [/^\/events(\/|$)/, EV],
  [/^\/invoices\/new/, ['invoices.create']],
  [/^\/invoices(\/|$)/, ['invoices.view']],
  [/^\/products(\/|$)/, ['invoices.view', 'events.edit', 'settings.edit']],
  [/^\/tasks(\/|$)/, ['tasks.view']],
  [/^\/(bookkeeping|bookkeeping-reports|transactions)(\/|$)/, ['bookkeeping.view']],
  [/^\/reports(\/|$)/, ['reports.view']],
  [/^\/settings\/forms/, ['settings.edit', 'events.edit']],
  [/^\/promo-codes(\/|$)/, ['events.edit']],
  [/^\/event-display(\/|$)/, EV],
  [/^\/badges(\/|$)/, ['events.checkin', 'events.edit']],
  [/^\/sponsor-links(\/|$)/, ['events.edit']],
  [/^\/renewals(\/|$)/, ['members.view']],
  [/^\/email-templates(\/|$)/, ['settings.view', 'email.view']],
  [/^\/email(\/|$)/, ['email.view']],
  [/^\/job-board(\/|$)/, ['members.view']],
  [/^\/letters(\/|$)/, ['letters.view']],
  [/^\/imports(\/|$)/, ['imports.run']],
  [/^\/settings(\/|$)/, ['settings.view']],
];

// null = everyone; otherwise any one of the listed permissions opens the page
export function pageKeys(pathname) {
  const p = String(pathname || '/').split('?')[0];
  for (const [re, keys] of PAGES) if (re.test(p)) return keys;
  return null;
}
